import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser, faStore, faTimes } from '@fortawesome/free-solid-svg-icons';

const WorkerFranchiseSelectorModal = ({ show, onClose, onSelectWorker, onSelectFranchise }) => {
    if (!show) return null;

    return (
        <div className="fixed z-50 inset-0 overflow-y-auto">
            <div className="flex items-center justify-center min-h-screen p-4 text-center sm:p-0">
                {/* Fondo oscuro */}
                <div
                    className="fixed inset-0 transition-opacity"
                    aria-hidden="true"
                    onClick={onClose}
                >
                    <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
                </div>

                {/* Contenido del modal */}
                <div
                    className="bg-white rounded-xl text-left overflow-hidden shadow-xl transform transition-all w-full max-w-md sm:my-8 sm:align-middle"
                    role="dialog"
                    aria-modal="true"
                    aria-labelledby="modal-title"
                    onClick={(e) => e.stopPropagation()}
                >
                    <div className="bg-white px-6 pt-6 pb-4">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-2xl font-bold text-gray-900">Añadir a la Tienda</h2>
                            <button
                                onClick={onClose}
                                className="text-gray-400 hover:text-gray-600 transition-colors"
                            >
                                <FontAwesomeIcon icon={faTimes} className="text-xl" />
                            </button>
                        </div>

                        {/* Opciones */}
                        <div className="space-y-4">
                            {/* Opción Trabajador */}
                            <button
                                onClick={() => {
                                    onSelectWorker();
                                    onClose();
                                }}
                                className="w-full bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white rounded-lg p-6 transition-all duration-300 transform hover:scale-105 shadow-lg"
                            >
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-4">
                                        <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                                            <FontAwesomeIcon icon={faUser} className="text-2xl" />
                                        </div>
                                        <div className="text-left">
                                            <h3 className="text-xl font-bold mb-1">Añadir Trabajador</h3>
                                            <p className="text-blue-100 text-sm">
                                                Gestiona empleados que pueden acumular puntos y canjear premios
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </button>

                            {/* Opción Franquiciado */}
                            <button
                                onClick={() => {
                                    onSelectFranchise();
                                    onClose();
                                }}
                                className="w-full bg-gradient-to-r from-purple-500 to-purple-600 hover:from-purple-600 hover:to-purple-700 text-white rounded-lg p-6 transition-all duration-300 transform hover:scale-105 shadow-lg"
                            >
                                <div className="flex items-center justify-between">
                                    <div className="flex items-center space-x-4">
                                        <div className="w-12 h-12 bg-white bg-opacity-20 rounded-full flex items-center justify-center">
                                            <FontAwesomeIcon icon={faStore} className="text-2xl" />
                                        </div>
                                        <div className="text-left">
                                            <h3 className="text-xl font-bold mb-1">Añadir Franquiciado</h3>
                                            <p className="text-purple-100 text-sm">
                                                Gestiona franquiciados con acceso a estadísticas y todas las funciones de trabajador
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </button>
                        </div>

                        {/* Footer */}
                        <div className="mt-6 pt-4 border-t border-gray-200">
                            <button
                                onClick={onClose}
                                className="w-full bg-gray-200 text-gray-700 px-4 py-2 rounded-lg hover:bg-gray-300 transition-colors"
                            >
                                Cancelar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WorkerFranchiseSelectorModal;


